module.exports = __webpack_public_path__ + "static/media/bulma.8f614cad.svg";